let Choices = require( 'choices.js' );

let ninja_forms = (function( $ ) {

	let selects = [];

	let _init = function( e, layoutView ) {
		if ( layoutView.$el.length > 0 ) {
			layoutView.$el.find( 'select' ).each( function() {
				selects[ $( this ).attr( 'id' ) ] = new Choices( $( this )[0], {
					shouldSort: false
				}  );
			} );
		}
	};

	$( document ).on( 'nfFormReady', _init );

	return {};

})( jQuery );

module.exports = ninja_forms;